import OverviewConfig from './overview/OverviewConfig';
import TripsConfig from './trips/TripsConfig';
import VehiclesConfig from './vehicles/VehiclesConfig';
import ReportsConfig from './reports/ReportsConfig';
import { Navigate } from 'react-router-dom';
import i18next from 'i18next';
import enGB from '@locales/exkursio/enGB';
import deAT from '@locales/exkursio/deAT';

i18next.addResourceBundle('enGB', 'exkursio', enGB);
i18next.addResourceBundle('deAT', 'exkursio', deAT);

const ExkursioConfigs = [
	OverviewConfig,
	TripsConfig,
	VehiclesConfig,
	ReportsConfig,
	{
		routes: [
			{
				path: '/eo',
				exact: true,
				element: <Navigate to="/eo/overview" />,
			}
		]
	}
];

export default ExkursioConfigs;
